import { useEffect, useRef, useState } from 'react';
import { benefits } from '@/mocks/audios';

export default function BenefitsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="beneficios"
      ref={sectionRef}
      className="w-full py-16 md:py-24 bg-background-100"
      aria-label="Benefícios dos áudios"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-accent-700 uppercase tracking-wider mb-3">
            Benefícios
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            O que a cura sonora pode fazer por você
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            As frequências sonoras atuam diretamente no seu sistema nervoso,
            promovendo mudanças profundas que se refletem em todas as áreas da sua vida.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.id}
              className={`bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 transition-all hover:border-accent-300/50 hover:-translate-y-0.5 hover:shadow-sm ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${index * 80}ms`, transitionDuration: '700ms' }}
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                <i className={`${benefit.icon} text-accent-600 text-xl`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div
          className={`text-center transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 bg-accent-50 border border-accent-200/60 rounded-2xl p-4 md:p-5">
            <p className="text-sm md:text-base font-medium text-foreground-800">
              Pronto para transformar sua vida? Comece agora mesmo.
            </p>
            <a
              href="https://pay.hotmart.com/T106583743Q?checkoutMode=2"
              onClick={(e) => e.preventDefault()}
              className="hotmart-fb hotmart__button-checkout inline-flex items-center whitespace-nowrap cursor-pointer px-6 py-2.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm transition-all hover:bg-accent-600"
            >
              Quero meu pacote
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}